module.exports = __webpack_public_path__ + "img/IMG_9442.bab22df6.jpg";